//
export const PERSIST_SUPPORT_ARTICLES = 'PERSIST_SUPPORT_ARTICLES'
//
export const ADD_SUPPORT_ARTICLE = 'ADD_SUPPORT_ARTICLE'
//
export const UPDATE_SUPPORT_ARTICLE = 'UPDATE_SUPPORT_ARTICLE'
//
export const DELETE_SUPPORT_ARTICLE = 'DELETE_SUPPORT_ARTICLE'
// 
export const UPDATE_CURRENT_ARTICLE = 'UPDATE_CURRENT_ARTICLE'
// 
export const PERSIST_CATEGORIES = 'PERSIST_CATEGORIES'
//
export const ADD_CATEGORY = 'ADD_CATEGORY'
//
export const UPDATE_CATEGORY = 'UPDATE_CATEGORY'
//
export const DELETE_CATEGORY = 'DELETE_CATEGORY'
//
export const UPDATE_CURRENT_CATEGORY = 'UPDATE_CURRENT_CATEGORY'
//
export const UPDATE_KNOWLEDGEBASE = 'UPDATE_KNOWLEDGEBASE'
